import { z } from 'zod';

/** Package-owned GPU residency and scoring policy; graph order still governs input execution. */
export const macroMatchingModeSchema = z.enum(['sequential', 'concurrent']);
export type MacroMatchingMode = z.infer<typeof macroMatchingModeSchema>;
/** An absent field retains the graph-frontier behavior of previously saved packages. */
export const DEFAULT_MACRO_MATCHING_MODE: MacroMatchingMode = 'sequential';
